import { LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms } from "../../../connected-components/hoc/query/__generated__/pdp-lease-offers.query";
import { getIsOfferInStock } from "../getIsOfferInStock/get-is-offer-in-stock";

export const getHasInStockOffers = (
  leaseOffers:
    | LeaseOffersQuery_search_Search_advert_Advert_leasingOffers_LeaseTerms[]
    | undefined,
) =>
  Boolean(
    leaseOffers?.some((offer) => getIsOfferInStock(offer.deliveryEstimate)),
  );
